export default "__VITE_ASSET__fb7d27c9__"